import { defineMessages } from 'react-intl'

export default defineMessages({
  description: {
    id: 'OrganizationGroupsMembersPage.Description',
    defaultMessage: 'If you want to edit your Groups, contact your SCIM administrator.'
  },
  email: {
    id: 'Email',
    defaultMessage: 'Email'
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  },
  loadingMembers: {
    id: 'OrganizationGroupsMembersPage.LoadingMembers',
    defaultMessage: 'Loading Members'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  none: {
    id: 'None',
    defaultMessage: 'None'
  },
  noSearchMembers: {
    id: 'OrganizationGroupsMembersPage.NoSearchMembers',
    defaultMessage: 'There are no members in this group match the search criteria.'
  },
  noMembers: {
    id: 'OrganizationGroupsMembersPage.NoMembers',
    defaultMessage: 'Currently there are no members in this group'
  },
  search: {
    id: 'OrganizationGroupsMembersPage.Search',
    defaultMessage: 'Search'
  },
  members: {
    id: 'users',
    defaultMessage: 'users'
  }
})
